import { render, staticRenderFns } from "./tabCustomerCashless.vue?vue&type=template&id=6b6967a4&"
import script from "./tabCustomerCashless.vue?vue&type=script&lang=js&"
export * from "./tabCustomerCashless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports